import React from "react";
import { Link } from "react-router-dom";
import { api, openConsult } from "../lib/api";
import Seo, { ORG_JSON_LD } from "../components/Seo";
import TwoSides from "../components/TwoSides";
import BuiltForPartners from "../components/BuiltForPartners";

const HERO_IMAGE =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_bark-help/artifacts/wo8ue6wc_ChatGPT%20Image%20Aug%2024%2C%202026%2C%2001_49_28%20PM.png";

export default function Home() {
  const [email, setEmail] = React.useState("");
  const [status, setStatus] = React.useState("idle");
  const [msg, setMsg] = React.useState("");

  const handleJoin = async (e) => {
    e.preventDefault();
    if (!email) return;
    setStatus("loading");
    try {
      const res = await api.post("/subscribe", { email, interested_in: ["private_launch_list"] });
      setMsg(res.data?.already ? "You're already on the list." : "You're on the private launch list.");
      setStatus("success");
      setEmail("");
    } catch {
      setMsg("Something went wrong. Try again.");
      setStatus("error");
    }
  };


  return (
    <div className="w-full bg-[#F8F2E8] text-[#1F1B18]" data-testid="the-studio-page">
      <Seo
        title="The Idea"
        description="Your dog's bored. Your dog's barking. askKimberley — a little help for the dog, a little relief for the human."
        path="/"
        image={HERO_IMAGE}
        jsonLd={ORG_JSON_LD}
      />

      <section
        className="relative w-full overflow-hidden flex items-center justify-center"
        style={{
          minHeight: "calc(100vh - 73px)",
          background: "linear-gradient(90deg, #AE8ABC 0%, #A47EB3 50%, #9A70A9 100%)",
        }}
        data-testid="hero-image-section"
      >
        <div
          className="pointer-events-none absolute inset-0"
          style={{ background: "radial-gradient(70% 60% at 50% 45%, rgba(255,255,255,0.10), rgba(0,0,0,0) 60%, rgba(60,30,80,0.25) 100%)" }}
        />
        <img
          src={HERO_IMAGE}
          alt="Don't you wish you had a friend you could text about your dog? That's askKimberley."
          data-testid="hero-vogue-image"
          className="ak-hero-img relative block w-full h-auto md:w-auto md:h-[calc(100vh-73px)] object-contain"
          style={{
            WebkitMaskImage: "linear-gradient(to right, transparent 0%, #000 10%, #000 90%, transparent 100%)",
            maskImage: "linear-gradient(to right, transparent 0%, #000 10%, #000 90%, transparent 100%)",
          }}
        />
      </section>

      <section
        className="flex flex-col items-center text-center px-6 pt-20 sm:pt-28 pb-24 sm:pb-32"
        data-testid="hero-section"
      >
        <p
          className="ak-reveal font-cormorant text-3xl sm:text-4xl lg:text-5xl leading-[1.2] text-[#1F1B18] max-w-4xl"
          style={{ animationDelay: "120ms" }}
          data-testid="hero-statement"
        >
          Your dog's bored. Your dog's barking.
          <br />
          <span className="font-semibold">askKimberley</span>
        </p>
        <p
          className="ak-reveal font-cormorant italic text-2xl sm:text-3xl lg:text-4xl leading-[1.3] text-[#D9739A] mt-6 max-w-4xl"
          style={{ animationDelay: "260ms" }}
          data-testid="hero-availability"
        >
          A little help for the dog — a little relief for the human.
        </p>

      </section>

      {/* Product teaser — designed image, click scrolls to launch list */}
      <section className="relative" data-testid="product-teaser">
        <a
          href="#private-launch-signup"
          onClick={(e) => {
            e.preventDefault();
            document.getElementById("private-launch-signup")?.scrollIntoView({ behavior: "smooth", block: "start" });
          }}
          data-testid="teaser-cta-join"
          aria-label="Join the private launch list"
          className="block cursor-pointer group"
        >
          <img
            src="/products/teaser.png"
            alt="A new way to think about dogs — barking & boredom."
            className="w-full h-auto block group-hover:opacity-95 transition"
          />
        </a>
      </section>

      <TwoSides />

      {/* FOOTER */}

      <div className="w-full bg-[#F8F2E8] border-y border-[#1F1B18]/10 py-8 sm:py-10 px-6 text-center" data-testid="divider-banner">
        <p className="font-typewriter text-xs sm:text-sm tracking-[0.4em] uppercase text-[#8B6B4A]">
          Natural products <span className="text-[#D9739A] mx-3">·</span> Canine expertise <span className="text-[#D9739A] mx-3">·</span> Digital support
        </p>
      </div>

      <BuiltForPartners />

      <footer id="private-launch-signup" className="bg-[#1F1B18] text-[#F8F2E8] pt-14 pb-8 border-t border-[#F8F2E8]/15" data-testid="site-footer">
        <div className="max-w-6xl mx-auto px-6">
          <div className="grid grid-cols-1 lg:grid-cols-[3fr_2fr] gap-10 lg:gap-16 items-end" data-testid="private-launch-signup">
            <div>
              <p className="font-typewriter text-sm tracking-[0.4em] uppercase text-[#F8F2E8]/60">The Private List</p>
              <p className="font-cormorant italic text-[#F8F2E8] mt-3 leading-snug whitespace-nowrap" style={{ fontSize: "clamp(1rem, 2.6vw, 1.875rem)" }}>
                Enter your email to request access to the private launch list.
              </p>
            </div>
            <div>
              <form onSubmit={handleJoin} className="flex flex-row gap-2 items-stretch">
                <input
                  type="email"
                  required
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="your@email.com"
                  data-testid="launch-list-email"
                  className="min-w-0 flex-1 bg-transparent border-b border-[#F8F2E8]/50 px-2 py-3 font-cormorant italic text-xl sm:text-2xl placeholder-[#F8F2E8]/40 text-[#F8F2E8] focus:outline-none focus:border-[#D9739A] transition"
                />
                <button
                  type="submit"
                  disabled={status === "loading"}
                  data-testid="launch-list-submit"
                  className="shrink-0 inline-flex items-center justify-center border border-[#F8F2E8] text-[#F8F2E8] px-6 sm:px-10 py-3 font-typewriter text-sm sm:text-base tracking-[0.25em] uppercase hover:bg-[#F8F2E8] hover:text-[#1F1B18] transition whitespace-nowrap disabled:opacity-50"
                >
                  {status === "loading" ? "…" : "Join"}
                </button>
              </form>
              {status === "success" && (
                <p className="font-cormorant italic text-xl text-[#D9739A] mt-4" data-testid="launch-list-success">
                  ✓ {msg}
                </p>
              )}
              {status === "error" && (
                <p className="font-cormorant italic text-lg text-red-400 mt-4">{msg}</p>
              )}
            </div>
          </div>

          <div className="mt-14 pt-6 border-t border-[#F8F2E8]/15 flex flex-col md:flex-row items-center justify-between gap-3">
            <p className="font-cormorant text-2xl tracking-[0.35em] uppercase">Ask Kimberley</p>
            <div className="flex items-center gap-5 flex-wrap justify-center">
              <a href="https://instagram.com/askkimberley.dog" target="_blank" rel="noreferrer"
                 className="font-typewriter text-sm tracking-widest opacity-80 hover:text-[#D9739A]">
                @askkimberley.dog
              </a>
              <p className="font-typewriter text-sm tracking-widest opacity-70">© 2026</p>
            </div>
            <Link to="/admin/login" className="font-typewriter text-sm tracking-widest opacity-40">Admin</Link>
          </div>
        </div>
      </footer>
    </div>
  );
}
